import type MailboxInfo from 'owa-client-ids/lib/schema/MailboxInfo';
import { lazyShowInImmersiveReader } from 'owa-immersive-reader-store';
import loadItemReadingPane from 'owa-mail-reading-pane-store/lib/actions/loadItemReadingPane';
import setItemPrintPaneViewState from 'owa-mail-reading-pane-store/lib/actions/setItemPrintPaneViewState';
import setItemReadingPaneViewState from 'owa-mail-reading-pane-store/lib/actions/setItemReadingPaneViewState';
import { setDeeplinkId } from 'owa-mail-reading-pane-store/lib/mutators/setDeeplinkId';
import { PopoutChildState, setPopoutChildState } from 'owa-popout-v2';

export interface ItemDeeplinkOptions {
    isReadOnly?: boolean;
    isDiscoveryView?: boolean;
    isImmersiveView?: boolean;
    isPrint?: boolean;
}

export function loadItemReadingPaneForDeeplink(
    itemId: string,
    mailboxInfo?: MailboxInfo,
    itemDeeplinkOptions?: ItemDeeplinkOptions,
    customCallback?: () => void
) {
    // Always set the deeplinkId if we are loading for deeplink
    setDeeplinkId(itemId, mailboxInfo);
    const isPrint = itemDeeplinkOptions?.isPrint;
    const clientItemId = { Id: itemId, mailboxInfo: mailboxInfo };
    loadItemReadingPane(
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (30,9): Argument of type '{ Id: string; mailboxInfo: MailboxInfo | undefined; }' is not assignable to parameter of type 'ClientItemId'.
        // @ts-expect-error
        clientItemId,
        null,
        viewState => {
            setItemReadingPaneViewState(viewState);
            if (isPrint) {
                setItemPrintPaneViewState(viewState);
            }
        },
        {
            isPrint: isPrint,
            isReadOnly: itemDeeplinkOptions?.isReadOnly,
            isDiscovery: itemDeeplinkOptions?.isDiscoveryView,
        },
        null /*loadItemOverrideFunction*/
    ).then(
        !!customCallback
            ? customCallback
            : () => {
                  if (itemDeeplinkOptions?.isImmersiveView) {
                      // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                      // -> Error TS2345 (52,66): Argument of type '{ Id: string; mailboxInfo: MailboxInfo | undefined; }' is not assignable to parameter of type 'ClientItemId'.
                      // @ts-expect-error
                      lazyShowInImmersiveReader.importAndExecute(clientItemId, 'ReadingPane');
                  } else {
                      setPopoutChildState(PopoutChildState.Ready);
                  }
              },
        () => {
            setPopoutChildState(PopoutChildState.Ready);
        }
    );
}
